import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

// Custom Component
import { useAuth } from "../../context/AuthContext";

// Images
import logo from "../../assets/images/logo.png";

// Icons
import { FiMenu, FiX } from "react-icons/fi";
import { GrLogout } from "react-icons/gr";

// Data
import { menuItems } from "../../Data/data";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/signin");
    } catch (error) {
      console.error("Failed to logout:", error);
    }
  };

  return (
    <div className="relative min-h-screen lg:flex">
      <div className="lg:hidden fixed top-2 left-2 z-50">
        <button
          onClick={toggleSidebar}
          className="p-1 rounded-md bg-white shadow-md"
        >
          {isOpen ? (
            <FiX size={24} color="#0D3D51" />
          ) : (
            <FiMenu size={24} color="#0D3D51" />
          )}
        </button>
      </div>

      <div
        className={`fixed inset-y-0 left-0 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:flex lg:flex-col bg-primary text-white w-64 z-40 h-screen max-h-screen overflow-y-auto`}
      >
        <div className="flex items-center justify-center py-4">
          <img src={logo} alt="Logo" className="w-36" />
        </div>

        <div className="flex-grow overflow-y-auto custom-scrollbar">
          <ul className="space-y-2 py-3 px-2">
            {menuItems.map(({ icon, path, name }, index) => (
              <Link
                to={path}
                key={index}
                className={`flex items-center gap-5 py-3 px-3 rounded-lg cursor-pointer ${
                  location.pathname.startsWith(path)
                    ? "bg-cloud text-dazzledBlue"
                    : "hover:bg-[#3A7FB4]"
                }`}
                onClick={() => setIsOpen(false)}
              >
                {icon}
                <li className="text-base">{name}</li>
              </Link>
            ))}
          </ul>
        </div>

        <div className="p-4 border-t border-gray-600">
          <button
            onClick={handleLogout}
            className="flex items-center gap-5 text-lg w-full"
          >
            <GrLogout className="text-2xl" />
            Logout
          </button>
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-30 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default Sidebar;
